<template>
    <div>
        <h4>Node Chapter 2</h4>
        <p>テスト用、、、。</p>
    </div>
</template>

<script>
    export default{
        name: 'NodeChapter2',
    }
</script>